// import { NgModule } from '@angular/core';
// import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
// import { AuthModule } from './applicationModules/authentication/auth.module';
// import { UserModule } from './applicationModules/users/user.module';
// import { CoreModule } from './applicationModules/core/core.module';
// import { SettingsModule } from './applicationModules/settings/settings.module';
// import { AdminModule } from './applicationModules/admin/admin.module';
// import { ESignatureModule } from './applicationModules/eSignature/eSignature.module';
// import { FileManagerModule } from './applicationModules/file-manager/file-manager.module';
// import { UnAuthenticateModule } from './unAuthenticatedModules/unAuthenticate.module';
// import { ProcessIntelligenceModule } from './applicationModules/process-intelligence/process-intelligence.module';
// import { ChatModule } from './applicationModules/chat/chat.module';
// import { TaskModule } from './applicationModules/task/task.module';
// import { WorkflowModule } from './applicationModules/workflow/workflow.module';
// import { CalendarModule } from './applicationModules/calendar/calendar.module';
// import { FacilityModule } from './applicationModules/facility/facility.module';
// import { NotificationModule } from './applicationModules/notification/notification.module';
// import { EcmAuthgaurdGuard } from './middleware/authentication/authgaurd/ecm-authgaurd.guard';
// import { ErrorVerificationComponent } from './middleware/shared/errorVerifcation/components/errorVerification/error-verification.component';
// import { ContactModule } from './applicationModules/contact/contact.module';
// import { CompanyModule } from './applicationModules/company/company.module';
// import { PageNotFoundComponent } from './middleware/common/pagenotfound/pagenotfound.component';
import { NoAccessComponent } from './middleware/common/noaccess/noaccess.component';
// import { DashboardModule } from './applicationModules/dashboard/dashboard.module';
// import { CalendarComponent } from './applicationModules/calendar/calendar.component';
// import { OrganizationModule } from './applicationModules/organization/organization.module';
// import { GroupListingTableComponent } from './middleware/common/group-listing-table/group-listing-table.component';
// import { ReportsModule } from './applicationModules/reports/reports.module';
// import { ResidentDashboardModule } from './applicationModules/residentdashboard/residentdashboard.module';
// import { ResidentViewModule } from './applicationModules/residentview/residentview.module';
// import { SfnReportingModule } from './applicationModules/sfnReporting/sfnReporting.module';
// import { MedicareApprovalModule } from './applicationModules/medicareapproval/medicareapproval.module';
// import { AiDocumentsCreatorModule } from './applicationModules/aiDocumentsCreator/aiDocumentsCreator.module';
// import { AiCostTrackingModule } from './applicationModules/aiCostTracking/aiCostTracking.module';
// import { ReferralManagementModule } from './applicationModules/referralManagement/referralManagement.module';
// import { InsuranceVerificationModule } from './applicationModules/insuranceVerification/insuranceVerification.module';

// const routes: Routes = [
//   {
//     path: 'auth',
//     loadChildren: () => import('./applicationModules/authentication/auth.module').then(m => m.AuthModule),
//   },
//   {
//     path: '',
//     redirectTo: 'auth/login',
//     pathMatch: 'full',
//   },
//   {
//     path: 'dashboard',
//     loadChildren: () => import('./applicationModules/dashboard/dashboard.module').then(m => m.DashboardModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//    {
//     path: 'residentdashboard',
//     loadChildren: () => import('./applicationModules/residentdashboard/residentdashboard.module').then(m => m.ResidentDashboardModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'residentview',
//     loadChildren: () => import('./applicationModules/residentview/residentview.module').then(m => m.ResidentViewModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'sfnReporting',
//     loadChildren: () => import('./applicationModules/sfnReporting/sfnReporting.module').then(m => m.SfnReportingModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'referralManagement',
//     loadChildren: () => import('./applicationModules/referralManagement/referralManagement.module').then(m => m.ReferralManagementModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'medicareapproval',
//     loadChildren: () => import('./applicationModules/medicareapproval/medicareapproval.module').then(m => m.MedicareApprovalModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//    {
//     path: 'aiDocuments',
//     loadChildren: () => import('./applicationModules/aiDocumentsCreator/aiDocumentsCreator.module').then(m => m.AiDocumentsCreatorModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'aiCostTracking',
//     loadChildren: () => import('./applicationModules/aiCostTracking/aiCostTracking.module').then(m => m.AiCostTrackingModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'insuranceVerification',
//     loadChildren: () => import('./applicationModules/insuranceVerification/insuranceVerification.module').then(m => m.InsuranceVerificationModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'core',
//     loadChildren: () => import('./applicationModules/core/core.module').then(m => m.CoreModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'contact',
//     loadChildren: () => import('./applicationModules/contact/contact.module').then(m => m.ContactModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'company',
//     loadChildren: () => import('./applicationModules/company/company.module').then(m => m.CompanyModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'esignature',
//     loadChildren: () => import('./applicationModules/eSignature/eSignature.module').then(m => m.ESignatureModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'task',
//     loadChildren: () => import('./applicationModules/task/task.module').then(m => m.TaskModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'workflow',
//     loadChildren: () => import('./applicationModules/workflow/workflow.module').then(m => m.WorkflowModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'intelligence',
//     loadChildren: () => import('./applicationModules/process-intelligence/process-intelligence.module').then(m => m.ProcessIntelligenceModule),
//   },
//   // {
//   //   path: 'calendar',
//   //   loadChildren: './applicationModules/calendar/calendar.component',
//   //  },
//   {
//     path: 'chat',
//     loadChildren: () => import('./applicationModules/chat/chat.module').then(m => m.ChatModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'filemanager',
//     loadChildren: () => import('./applicationModules/file-manager/file-manager.module').then(m => m.FileManagerModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'request',
//     loadChildren: () => import('./unAuthenticatedModules/unAuthenticate.module').then(m => m.UnAuthenticateModule),
//   },
//   {
//     path: 'users',
//     loadChildren: () => import('./applicationModules/users/user.module').then(m => m.UserModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'moduleMaster',
//     loadChildren: './applicationModules/moduleMaster/module-master.module#ModuleMasterModule',
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'settings',
//     loadChildren: () => import('./applicationModules/settings/settings.module').then(m => m.SettingsModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'reports',
//     loadChildren: () => import('./applicationModules/reports/reports.module').then(m => m.ReportsModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'admin',
//     loadChildren: () => import('./applicationModules/admin/admin.module').then(m => m.AdminModule),
//     canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'verificationError',
//     component: ErrorVerificationComponent,
//   },
//   {
//     path: 'unauthorised',
//     component: PageNotFoundComponent,
//   },
//   {
//     path: 'gridView',
//     component: GroupListingTableComponent,
//   },
//   {
//     path: 'organization',
//     loadChildren: () => import('./applicationModules/organization/organization.module').then(m => m.OrganizationModule),
//     //canActivate: [EcmAuthgaurdGuard],
//   },
//   {
//     path: 'calendar',
//     loadChildren: () => import('./applicationModules/calendar/calendar.module').then(m => m.CalendarModule),
//   },
//   {
//     path: 'facility',
//     loadChildren: () => import('./applicationModules/facility/facility.module').then(m => m.FacilityModule),
//   },
//   {
//     path: 'notifications',
//     loadChildren: () => import('./applicationModules/notification/notification.module').then(m => m.NotificationModule),
//   },


//   {
//     path: '**',
//     component: PageNotFoundComponent
//   }
// ];

// @NgModule({
//   //imports: [RouterModule.forRoot(routes)],
//   imports: [RouterModule.forRoot(routes, { enableTracing: false, preloadingStrategy: PreloadAllModules })],
//   // imports: [RouterModule.forRoot(routes,{useHash:true,enableTracing:false,preloadingStrategy:PreloadAllModules})],
//   exports: [RouterModule],
// })
// export class AppRoutingModule { }


import { NgModule } from '@angular/core';
import {
  Routes,
  RouterModule,
  NoPreloading
} from '@angular/router';

import { EcmAuthgaurdGuard } from './middleware/authentication/authgaurd/ecm-authgaurd.guard';

import { ErrorVerificationComponent } from './middleware/shared/errorVerifcation/components/errorVerification/error-verification.component';
import { PageNotFoundComponent } from './middleware/common/pagenotfound/pagenotfound.component';
import { GroupListingTableComponent } from './middleware/common/group-listing-table/group-listing-table.component';

const routes: Routes = [

  // =========================
  // AUTH
  // =========================
  {
    path: 'auth',
    loadChildren: () =>
      import('./applicationModules/authentication/auth.module')
        .then(m => m.AuthModule)
  },

  // =========================
  // DEFAULT
  // =========================
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },

  // =========================
  // DASHBOARD
  // =========================
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./applicationModules/dashboard/dashboard.module')
        .then(m => m.DashboardModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  {
    path: 'residentdashboard',
    loadChildren: () =>
      import('./applicationModules/residentdashboard/residentdashboard.module')
        .then(m => m.ResidentDashboardModule)
  },

  {
    path: 'residentview',
    loadChildren: () =>
      import('./applicationModules/residentview/residentview.module')
        .then(m => m.ResidentViewModule)
  },

  // =========================
  // REPORTS
  // =========================
  {
    path: 'sfnReporting',
    loadChildren: () =>
      import('./applicationModules/sfnReporting/sfnReporting.module')
        .then(m => m.SfnReportingModule)
  },

  {
    path: 'reports',
    loadChildren: () =>
      import('./applicationModules/reports/reports.module')
        .then(m => m.ReportsModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // REFERRAL
  // =========================
  {
    path: 'referralManagement',
    loadChildren: () =>
      import('./applicationModules/referralManagement/referralManagement.module')
        .then(m => m.ReferralManagementModule)
  },

  // =========================
  // MEDICARE
  // =========================
  {
    path: 'medicareapproval',
    loadChildren: () =>
      import('./applicationModules/medicareapproval/medicareapproval.module')
        .then(m => m.MedicareApprovalModule)
  },

  // =========================
  // AI DOCUMENTS
  // =========================
  {
    path: 'aiDocuments',
    loadChildren: () =>
      import('./applicationModules/aiDocumentsCreator/aiDocumentsCreator.module')
        .then(m => m.AiDocumentsCreatorModule)
  },

  // =========================
  // AI COST
  // =========================
  {
    path: 'aiCostTracking',
    loadChildren: () =>
      import('./applicationModules/aiCostTracking/aiCostTracking.module')
        .then(m => m.AiCostTrackingModule)
  },

  // =========================
  // INSURANCE
  // =========================
  {
    path: 'insuranceVerification',
    loadChildren: () =>
      import('./applicationModules/insuranceVerification/insuranceVerification.module')
        .then(m => m.InsuranceVerificationModule)
  },

  // =========================
  // CORE
  // =========================
  {
    path: 'core',
    loadChildren: () =>
      import('./applicationModules/core/core.module')
        .then(m => m.CoreModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // CONTACT
  // =========================
  {
    path: 'contact',
    loadChildren: () =>
      import('./applicationModules/contact/contact.module')
        .then(m => m.ContactModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // COMPANY
  // =========================
  {
    path: 'company',
    loadChildren: () =>
      import('./applicationModules/company/company.module')
        .then(m => m.CompanyModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // E-SIGNATURE
  // =========================
  {
    path: 'esignature',
    loadChildren: () =>
      import('./applicationModules/eSignature/eSignature.module')
        .then(m => m.ESignatureModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // TASK
  // =========================
  {
    path: 'task',
    loadChildren: () =>
      import('./applicationModules/task/task.module')
        .then(m => m.TaskModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // FILE MANAGER
  // =========================
  {
    path: 'filemanager',
    loadChildren: () =>
      import('./applicationModules/file-manager/file-manager.module')
        .then(m => m.FileManagerModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // PUBLIC REQUEST
  // =========================
  {
    path: 'request',
    loadChildren: () =>
      import('./unAuthenticatedModules/unAuthenticate.module')
        .then(m => m.UnAuthenticateModule)
  },

  // =========================
  // PUBLIC MAIL PAGE
  // =========================
  // Opened from the link inside a text message: /mail/<short code>.
  // No guard -- the recipient is not signed in.
  {
    path: 'mail',
    loadChildren: () =>
      import('./unAuthenticatedModules/mail/mail.module')
        .then(m => m.MailModule)
  },

  // =========================
  // USERS
  // =========================
  {
    path: 'users',
    loadChildren: () =>
      import('./applicationModules/users/user.module')
        .then(m => m.UserModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // SETTINGS
  // =========================
  {
    path: 'settings',
    loadChildren: () =>
      import('./applicationModules/settings/settings.module')
        .then(m => m.SettingsModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // ADMIN
  // =========================
  {
    path: 'admin',
    loadChildren: () =>
      import('./applicationModules/admin/admin.module')
        .then(m => m.AdminModule),
    canActivate: [EcmAuthgaurdGuard]
  },

  // =========================
  // ORGANIZATION
  // =========================
  {
    path: 'organization',
    loadChildren: () =>
      import('./applicationModules/organization/organization.module')
        .then(m => m.OrganizationModule)
  },

  // =========================
  // NOTIFICATIONS
  // =========================
  // {
  //   path: 'notifications',
  //   loadChildren: () =>
  //     import('./applicationModules/notification/notification.module')
  //       .then(m => m.NotificationModule)
  // },

  {
    path: 'workflow',
    loadChildren: () => import('./applicationModules/workflow/workflow.module').then(m => m.WorkflowModule)
    //canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'calendar',
    loadChildren: () => import('./applicationModules/calendar/calendar.module').then(m => m.CalendarModule)
  },

  {
    path: 'facility',
    loadChildren: () => import('./applicationModules/facility/facility.module').then(m => m.FacilityModule),
  },

  // =========================
  // COMMON
  // =========================
  {
    path: 'verificationError',
    component: ErrorVerificationComponent
  },

  {
    path: 'unauthorised',
    component: PageNotFoundComponent
  },

  {
    // Logged in but the role has no modules assigned
    path: 'noaccess',
    component: NoAccessComponent,
    canActivate: [EcmAuthgaurdGuard]
  },

  {
    path: 'gridView',
    component: GroupListingTableComponent
  },

  // =========================
  // 404
  // =========================
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      preloadingStrategy: NoPreloading,
      initialNavigation: true,
      useHash: false,
      scrollPositionRestoration: 'disabled',
      anchorScrolling: 'disabled'
    })
  ],

  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }